module.exports = __webpack_public_path__ + "img/dfinity.982e6ac1.png";